export default "__VITE_ASSET__M$xc6CCq__"